import React from 'react';

export const TrstdAppLoginIcon = () => {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="60" height="60" rx="12" fill="#024DF0" />
      <rect
        x="9.91126"
        y="17.4112"
        width="40.1775"
        height="25.1775"
        rx="12.5887"
        fill="white"
        stroke="white"
        strokeWidth="1.8225"
      />
      <circle cx="37.5" cy="29.9999" r="12" fill="#FFD200" />
      <circle cx="37.5" cy="29.9999" r="12" fill="#024DF0" />
      <path
        d="M40.7963 32.6894C39.6083 34.4498 37.9451 36.059 35.7419 36.059C33.3983 36.059 32.0267 34.5903 32.0267 32.2143C32.0267 28.3695 34.8779 24.6002 38.8739 24.6002C40.2131 24.5894 42.0275 25.1294 42.0275 26.7602C42.0275 29.6762 37.4591 30.6482 35.2127 31.2314C35.1263 31.6634 35.0724 32.171 35.0616 32.6894C35.0616 33.7046 35.6015 34.6335 36.7139 34.6335C38.1611 34.6335 39.3168 33.2403 40.17 32.2035L40.7963 32.6894ZM39.5543 26.4147C39.5543 25.8207 39.2195 25.3563 38.6039 25.3563C36.7463 25.3563 35.7852 28.9742 35.4288 30.389C37.1568 29.8706 39.5543 28.4559 39.5543 26.4147Z"
        fill="white"
      />
    </svg>
  );
};
